export type SupportedCulture = { key: string; textKey: string; fallback: string };

export const SUPPORTED_CULTURES: readonly SupportedCulture[] = [
  { key: 'en-US', textKey: 'Global_LanguageSelector_EN', fallback: 'English' },
  { key: 'cs', textKey: 'Global_LanguageSelector_CS', fallback: 'Czech' },
  { key: 'sk', textKey: 'Global_LanguageSelector_SK', fallback: 'Slovak' },
  { key: 'hu', textKey: 'Global_LanguageSelector_HU', fallback: 'Hungarian' },
  { key: 'de-AT', textKey: 'Global_LanguageSelector_DE', fallback: 'German' },
  { key: 'ro', textKey: 'Global_LanguageSelector_RO', fallback: 'Romanian' },
  { key: 'ro-MD', textKey: 'Global_LanguageSelector_MD', fallback: 'Romanian(Moldova)' },
  { key: 'it', textKey: 'Global_LanguageSelector_IT', fallback: 'Italian' },
];
